import React from "react";
import { customDateFormatWithTime, textFormatter } from "components/Common/formatter";
import CustomLink from "components/Common/buttons/CustomLink";
import ButtonGroupContainer from "components/Common/buttons/ButtonGroupContainer";
import ButtonGroup from "components/Common/buttons/ButtonGroup";
import approvalIcon from "assets/images/svg/approval_img.svg";

export const awaitingPreparationMeterListColumns = openValidateModal => [
  {
    title: "Barcode",
    dataIndex: "barcode",
    render: cellContent => textFormatter(cellContent),
    sort: true,
  },
  {
    title: "Serial Number",
    dataIndex: "serial",
    render: cellContent =>
      cellContent !== "UNKNOWN" ? (
        <CustomLink underlined target="_blank" to={`/warehouse/assets/${cellContent}?t=serialNumber`}>
          {cellContent}
        </CustomLink>
      ) : (
        cellContent
      ),
    sort: true,
  },
  {
    title: "Meter Type",
    dataIndex: "type",
    render: cellContent => textFormatter(cellContent),
    sort: true,
  },
  {
    title: "Created at",
    dataIndex: "createdAt",
    render: cellContent => textFormatter(customDateFormatWithTime(cellContent)),
    sort: true,
  },
  {
    dataIndex: "",
    title: "",
    width: "70px",
    render: (text, record) => (
      <ButtonGroupContainer hasMobileView>
        <ButtonGroup tooltipTitle="Validate" icon={approvalIcon} handleClick={() => openValidateModal(record.id)} />
      </ButtonGroupContainer>
    ),
  },
];
